import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnDestroy
} from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import {
  ConfigurationService,
  DEFAULT_ACCENT_COLOR,
  DEFAULT_BUTTON_COLOR,
  DEFAULT_COLORS
} from "../../services/configuration.service";

type ButtonLocationType = "left" | "right";
type ColorSelectionType = "accent" | "button";

@Component({
  selector: "onsip-sayso-color-picker",
  templateUrl: "./sayso-color-picker.component.html",
  styleUrls: ["./sayso-color-picker.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SaysoColorPickerComponent implements OnInit, OnDestroy {
  @Output() accentColorChange = new EventEmitter<string>();
  @Output() buttonColorChange = new EventEmitter<string>();
  @Output() buttonPositionChange = new EventEmitter<ButtonLocationType>();
  @Output() gradientOverlayChange = new EventEmitter<boolean>();
  accentColor!: Observable<string>;
  buttonColor!: Observable<string>;
  defaultColors = DEFAULT_COLORS;
  gradientOverlay!: Observable<boolean>;

  private _buttonPosition!: ButtonLocationType;
  private unsubscriber = new Subscription();

  constructor(private config: ConfigurationService) {}

  get buttonPosition(): ButtonLocationType {
    return this._buttonPosition;
  }

  set buttonPosition(position: ButtonLocationType) {
    this.config.editConfigProperty("horizontalPositionDirection", position).then(() => {
      this.buttonPositionChange.emit(position);
    });
  }

  ngOnInit(): void {
    this.accentColor = this.config.state.pipe(
      map(state => state.orgConfig.accentColor || DEFAULT_ACCENT_COLOR)
    );

    this.buttonColor = this.config.state.pipe(
      map(state => state.orgConfig.buttonColor || DEFAULT_BUTTON_COLOR)
    );

    this.gradientOverlay = this.config.state.pipe(
      map(state => state.orgConfig.gradientOverlay || false)
    );

    this.unsubscriber.add(
      this.config.state.subscribe(state => {
        this._buttonPosition = state.orgConfig.horizontalPositionDirection || "right";
      })
    );
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }

  toggleGradientOverlay(checked: boolean): void {
    this.config
      .editConfigProperty("gradientOverlay", checked)
      .then(() => this.gradientOverlayChange.emit(checked));
  }

  toggleColorPicker(value: string, type: ColorSelectionType): void {
    if (type === "accent") {
      this.config
        .editConfigProperty("accentColor", value)
        .then(() => this.accentColorChange.emit(value));
    }

    if (type === "button") {
      this.config
        .editConfigProperty("buttonColor", value)
        .then(() => this.buttonColorChange.emit(value));
    }
  }
}
